import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../../../siteManagement/serverApi/types/ISiteNameWithId';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { ISubscription } from '../types/ISubscription';

export interface IGetSubscriptionsResult extends IGetItemsResult {
  subscriptions: ISubscription[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  users: IUser[];
}

export class GetSubscriptionsRequest extends Request<IGetItemsParams, IGetSubscriptionsResult> {
  constructor(params: IGetItemsParams) {
    super('getSubscriptions', params);
  }
}
